module.exports = __webpack_public_path__ + "dantd-demo/static/media/chahua.471ebf29.png";